export * from './ArrivedLogo';
export * from './GradientIcon';
export * from './Parallelogram';
export * from './Square';
export * from './Triangle';
